import styled from '@emotion/styled'

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100%;
  background-color: ${props => props.theme.colors.whisper};
  width: 100%;
`
export default CardContainer
